import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import NavBar from "../../Components/NavBar";
import HomeBanner from "../../Components/Home/HomeBanner";
import { OurDesktopProducts } from "./OurDesktopProducts";
import Credentials from "../../Components/Credentials";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import OurProducts from "../../Components/OurProducts";

gsap.registerPlugin(ScrollTrigger);

function HomePage() {
  const [isActive, setIsActive] = useState(false);
  const bannerRef = useRef(null);
  const scrollToRef = useRef(null);
  const credentialsRef = useRef(null);

  const scrollToContent = () => {
    if (scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 1040) {
      setIsActive(false);
    } else {
      setIsActive(true);
    }
  }, []);

  return (
    <div className="main-container">
      <NavBar />
      <section ref={bannerRef} className="panel">
        <HomeBanner scrollCallBack={scrollToContent} />
      </section>
      {/* {isActive && (
        <section ref={scrollToRef} className="panel">
          <OurDesktopProducts />
        </section>
      )} */}
      {isActive && <OurProducts ref={scrollToRef} />}
      {!isActive && <OurProducts ref={scrollToRef} />}

      <section ref={credentialsRef} className="panel">
        <Credentials />
        <FAQs bgWhite={false} />
        <HealthInsuranceHero />
      </section>
    </div>
  );
}

export default HomePage;
